"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyAddressProvider = exports.verifyAddressClient = exports.getClientUri = void 0;
var react_1 = __importDefault(require("react"));
var client_1 = require("@apollo/client");
var apollo_link_context_1 = require("apollo-link-context");
__exportStar(require("./bindings"), exports);
__exportStar(require("./components"), exports);
var DEVELOPMENT_URI = 'http://localhost:8083';
var PRODUCTION_URI = 'https://fgflrw2qoi.execute-api.us-east-1.amazonaws.com/dev/graphql';
var CLUSTER_URI = 'https://prod.coinapp.co/verifier';
var getClientUri = function (stage) {
    switch (stage) {
        case 'development':
            return DEVELOPMENT_URI;
        case 'cluster':
            return CLUSTER_URI;
        default:
            return PRODUCTION_URI;
    }
};
exports.getClientUri = getClientUri;
var verifyAddressClient = function (stage, getRequestContext) {
    var uri = (0, exports.getClientUri)(stage);
    var authLink = (0, apollo_link_context_1.setContext)(function (op, _a) {
        var headers = _a.headers;
        return __awaiter(void 0, void 0, void 0, function () {
            var context;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, (getRequestContext === null || getRequestContext === void 0 ? void 0 : getRequestContext())];
                    case 1:
                        context = _b.sent();
                        return [2 /*return*/, {
                                headers: __assign(__assign({}, headers), context === null || context === void 0 ? void 0 : context.headers),
                            }];
                }
            });
        });
    });
    return new client_1.ApolloClient({
        cache: new client_1.InMemoryCache(),
        link: (0, client_1.concat)(authLink, new client_1.HttpLink({ uri: uri })),
    });
};
exports.verifyAddressClient = verifyAddressClient;
var VerifyAddressProvider = function (_a) {
    var stage = _a.stage, children = _a.children, getRequestContext = _a.getRequestContext;
    var client = (0, exports.verifyAddressClient)(stage, getRequestContext);
    return react_1.default.createElement(client_1.ApolloProvider, { client: client }, children);
};
exports.VerifyAddressProvider = VerifyAddressProvider;
//# sourceMappingURL=index.js.map